/**
 * @desc 提柜信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CabinFactoryPickupCabinRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryWhole/pickupCabin`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
